import { styled } from 'linaria/react';
import t from '@jetshop/intl';
import get from 'lodash.get';
import React from 'react';
import { Query } from 'react-apollo';
import pagesQuery from './PagesQuery.gql';
import ContentPageLink from '@jetshop/ui/ContentPageLink';
import { css } from 'linaria';

export const pageListStyle = css`
  .list-wrapper {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    max-width: 100%;
    overflow: hidden;
  }
  ul {
    flex: 1;
    li {
      max-width: 200px;
      text-align: left;
      min-height: 24px;

      a {
        min-height: 24px;
        height: 100%;
        line-height: 1.2;
        display: inline-block;
      }
    }
  }
`;

const FooterLinks = ({ selectedChannel }) => (
  <Query query={pagesQuery}>
    {({ data }) => {
      const pages = get(data, 'pages')?.filter(
        page => page.primaryRoute && page.id != 62
      );
      if (!pages) return null;

      // Split pages into two arrays - adjust numbers as needed
      const firstColumn = pages.slice(0, 8);
      const secondColumn = pages.slice(8);

      return (
        <div className={pageListStyle}>
          <h2>{t('Customer service')}</h2>
          <div className="list-wrapper">
            <ul>
              {selectedChannel?.id === 5 && (
                <li>
                  <a href="/handelsbetingelser#return-policy">
                    Åpent kjøp og retur
                  </a>
                </li>
              )}
              {firstColumn.map(page => (
                <li key={page.id}>
                  {page.hasExternalUrl ? (
                    <a
                      target={page.externalUrl.target}
                      href={page.externalUrl.link}
                    >
                      {page.name}
                    </a>
                  ) : (
                    <ContentPageLink page={page}>{page.name}</ContentPageLink>
                  )}
                </li>
              ))}
            </ul>

            <ul>
              {secondColumn.map(page => (
                <li key={page.id}>
                  {page.hasExternalUrl ? (
                    <a
                      target={page.externalUrl.target}
                      href={page.externalUrl.link}
                    >
                      {page.name}
                    </a>
                  ) : (
                    <ContentPageLink page={page}>{page.name}</ContentPageLink>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      );
    }}
  </Query>
);

export default FooterLinks;
